import React from 'react';
import './ProductCard.css'; // Assuming you will create a CSS file for the card styles

function ProductCard({ title, description, link }) {
  return (
    <div className="product-card">
      <h2>{title}</h2>
      <p>{description}</p>
      <a href={link} target="_blank" rel="noopener noreferrer">View on GitHub</a>
    </div>
  );
}

export default ProductCard;
